module.exports = __webpack_public_path__ + "img/map.72ab1943.png";